var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1253 5.34V3C25.1253 2.385 24.6153 1.875 24.0003 1.875C23.3853 1.875 22.8753 2.385 22.8753 3V5.25H13.1253V3C13.1253 2.385 12.6153 1.875 12.0003 1.875C11.3853 1.875 10.8753 2.385 10.8753 3V5.34C6.82533 5.715 4.86034 8.13 4.56034 11.715C4.53034 12.15 4.89034 12.51 5.31034 12.51H30.6903C31.1253 12.51 31.4853 12.135 31.4403 11.715C31.1403 8.13 29.1753 5.715 25.1253 5.34Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.76C30.825 14.76 31.5 15.435 31.5 16.26V25.5C31.5 30 29.25 33 24 33H12C6.75 33 4.5 30 4.5 25.5V16.26C4.5 15.435 5.175 14.76 6 14.76H30Z",
    fill: "#00FFB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2604 22.485L21.5104 23.25H21.4954L16.9504 27.795C16.7554 27.99 16.3504 28.2 16.0654 28.23L14.0404 28.53C13.3054 28.635 12.7954 28.11 12.9004 27.39L13.1854 25.35C13.2304 25.065 13.4254 24.675 13.6204 24.465L18.1804 19.92L18.9304 19.155C19.4254 18.66 19.9804 18.3 20.5804 18.3C21.0904 18.3 21.6454 18.54 22.2604 19.155C23.6104 20.505 23.1754 21.57 22.2604 22.485Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/calendar-edit.755feefcd1fd9161adcb3cca9a8f2bc3.svg";
export { ForwardRef as ReactComponent };